<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text"
            >Cambiar contraseña</CCardHeader
          >
          <CCardBody>
            <CRow>
              <CCol md="6" lg="16">
                <label>Contraseña actual:</label>
                <CInput
                  :value.sync="password"
                  placeholder="Contraseña actual..."
                  type="password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6" lg="6">
                <label>Nueva contraseña:</label>
                <CInput
                  :value.sync="$v.newPassword.$model"
                  :isValid="checkIfValid('newPassword')"
                  placeholder="Nueva contraseña..."
                  invalidFeedback="Campo requerido, mínimo 4 caracteres, máximo 16 caracteres"
                  type="password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="6" lg="6">
                <label>Confirmar contraseña:</label>
                <CInput
                  :value.sync="$v.confirmPassword.$model"
                  :isValid="checkIfValid('confirmPassword')"
                  placeholder="Confirmar contraseña..."
                  type="password"
                  invalidFeedback="La contraseña no es igual"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12" lg="12">
                <CButton
                  @click="getCambio()"
                  class="btn-custom-width"
                  color="primary"
                >
                  <div v-if="isLoading">
                    <div
                      class="w-100 d-flex justify-content-center align-items-center"
                    >
                      <div
                        class="sk-flow height-custom flex align-items-center"
                      >
                        <div class="sk-flow-dot bg-load-white"></div>
                        <div class="sk-flow-dot bg-load-white"></div>
                        <div class="sk-flow-dot bg-load-white"></div>
                      </div>
                    </div>
                  </div>
                  <span v-else>Guardar</span>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardBody>
            <CChartBar
              ref="ch"
              style="height:300px"
              :datasets="[
                {
                  data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
                  backgroundColor: '#E55353',
                  label: 'Sales'
                }
              ]"
              labels="months"
              :options="{
                maintainAspectRatio: false,
                onClick: e => chart(this, e)
              }"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>  -->
    <!-- <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardBody>
            <CChartLine
              ref="ch"
              :options="{
                maintainAspectRatio: false,
                onClick: e => chart(this, e)
              }"
              :datasets="defaultDatasets"
              :labels="labels"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->

    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
    <CModal
      size="sm"
      title="Cambio de contraseña"
      :centered="true"
      color="primary"
      :show.sync="successModal"
      >{{ success }}</CModal
    >
  </div>
</template>

<style src="spinkit/spinkit.min.css"></style>

<script>
import { validationMixin } from "vuelidate";
import { CChartBar, CChartLine } from "@coreui/vue-chartjs";
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  name: "ChangePassword",
  components: { CChartBar, CChartLine },
  data() {
    return {
      changeModal: true,
      password: "",
      newPassword: "",
      confirmPassword: "",
      isLoading: false,
      error: "",
      labels: ["uno", "dos", "tres", "cuatro", "cinco", "seis", "siete"],
      warningModal: false,
      successModal: false,
      success: ""
    };
  },

  mixins: [validationMixin],
  validations: {
    newPassword: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(16)
    },
    confirmPassword: {
      sameAsPassword: sameAs("newPassword")
    }
  },

  computed: {
    usuario() {
      return this.$store.state.user;
    },

    // isValidPassword() {
    //   return !this.$v.password.$invalid;
    // },
    isValidNewPassword() {
      return !this.$v.newPassword.$invalid;
    },
    isValidConfirmPassword() {
      return !this.$v.confirmPassword.$invalid;
    },

    defaultDatasets() {
      return [
        {
          label: "Data One",
          backgroundColor: "rgb(228,102,81,0.9)",
          data: [30, 39, 10, 50, 30, 70, 35]
        },
        {
          label: "Data Two",
          backgroundColor: "rgb(0,216,255,0.9)",
          data: [39, 80, 40, 35, 40, 20, 45]
        },
        {
          label: "Prueba",
          backgroundColor: "plum",
          data: [50, 50, 80, 85, 96, 107, 120]
        }
      ];
    }
  },

  methods: {
    chart(item, event) {
      console.log(event);
      // console.log(this.$refs["ch"].chart.getElementsAtEvent(event));
      console.log(this.$refs["ch"].chart.getElementAtEvent(event));
      // console.log(this.$refs["ch"].chart.getDatasetAtEvent(event));
      // console.log(this.$refs["ch"].getElementsAtEvent(event));
      // myNewChart.getElementsAtEvent(event)
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateCambio() {
      // this.$v.password.$touch();
      this.$v.newPassword.$touch();
      this.$v.confirmPassword.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    resetCambio() {
      this.password = "";
      this.newPassword = "";
      this.confirmPassword = "";
      // this.$v.password.$reset();
      this.$v.newPassword.$reset();
      this.$v.confirmPassword.$reset();
    },
    getCambio() {
      this.validateCambio();

      if (this.isValidNewPassword && this.isValidConfirmPassword) {
        this.isLoading = true;
        this.$store
          .dispatch("customUsuarioModificarPasswordHTTP", {
            usuario_id: this.usuario,
            contrasena_anterior: this.password,
            contrasena_nueva: this.newPassword
          })
          .then(() => {
            this.success = "Cambio de contraseña exitoso";
            this.successModal = true;
            this.resetCambio();
            //  this.$router.push({ name: "Ubicaciones" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
            this.isLoading = false;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 20px;
}
</style>
